import { useDebounceEffect } from "ahooks";
import { OrderChatMessage } from "@core/types";
import useMarkOrderChatReadMutation from "./useMarkOrderChatReadMutation";

const MARK_READ_DEBOUNCE_MS = 500;

const useAutoMarkChatRead = (
  chatId: number | undefined,
  latestMessage: OrderChatMessage | undefined,
  orderId: number | undefined,
) => {
  const markAsRead = useMarkOrderChatReadMutation();

  const isInbound = !!latestMessage && latestMessage.senderType !== "customer" && latestMessage.id > 0;
  const triggerMessageId = isInbound ? latestMessage!.id : 0;

  useDebounceEffect(
    () => {
      if (!chatId || !triggerMessageId) return;
      markAsRead.mutate({ chatId, orderId });
    },
    [chatId, triggerMessageId, orderId],
    { wait: MARK_READ_DEBOUNCE_MS },
  );
};

export default useAutoMarkChatRead;
